{
  "de": {
    "textEditor": {
      "editKinds": {
        "help_me_write": "Schreibhilfe",
        "spellcheck": "Rechtschreibung",
        "summarize": "Zusammenfassen",
        "translate": "Übersetzen"
      },
      "headers": {
        "aiTextModal": "KI-Assistenz: {title}"
      },
      "hints": {
        "loadingDocument": "Dokument wird geladen...",
        "noTextSelected": "Kein Text ausgewählt",
        "progressMessage": "Bearbeitung läuft...",
        "prompt": "Zum Beispiel: <strong>Bundesländer in Deutschland</strong> oder <strong>Rom der Antike</strong>"
      },
      "links": {
        "helpMeWrite": "Hilf mir zu schreiben",
        "spellcheck": "Rechtschreibung & Grammatik korrigieren",
        "summarize": "Zusammenfassen",
        "translate": "Übersetzen"
      },
      "placeholder": "Erstelle gemeinsam Texte mit unterschiedlichen Medieninhalten wie formatiertem Text, Bildern und externen Links.",
      "placeholders": {
        "aiPromptModal": "Thema eingeben..."
      }
    }
  }
}
